module.exports = __webpack_public_path__ + "static/media/2018-11-11-01.5338f728.jpg";